import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { CompanyDto, CreateCompanyDto, UpdateCompanyDto } from 'interfaces/companies/company';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface TenantCompanyService {
  list(): Promise<CompanyDto[]>;
  get(id: string): Promise<CompanyDto>;
  create(postData: CreateCompanyDto): Promise<CompanyDto>;
  update(id: string, postData: UpdateCompanyDto): Promise<CompanyDto>;
}

const TENANT_COMPANY_PATH = '/tenant/companies';

const endpoints = {
  list: TENANT_COMPANY_PATH,
  get: (id: string) => `${TENANT_COMPANY_PATH}/${id}`,
  create: TENANT_COMPANY_PATH,
  update: (id: string) => `${TENANT_COMPANY_PATH}/${id}`,
};

export const tenantCompaniesService: TenantCompanyService = {
  list: async (): Promise<CompanyDto[]> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto[]>> = await apiClient.get(endpoints.list);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  get: async (id: string): Promise<CompanyDto> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto>> = await apiClient.get(endpoints.get(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  create: async (postData: CreateCompanyDto): Promise<CompanyDto> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto>> = await apiClient.post(endpoints.create, postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  update: async (id: string, postData: UpdateCompanyDto): Promise<CompanyDto> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto>> = await apiClient.put(endpoints.update(id), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
